import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, ProductLine, NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { trackNavigationClick } from '../events'

export const ExecutiveLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = ProductLine.EXECUTIVE,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof ProductLine)[keyof typeof ProductLine]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.executive')

  const handleExecutiveClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={paths.executive}
      className={className}
      onClick={handleExecutiveClick}
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
}
